import React from 'react'
import './styles.scss';
import { ReactComponent as GcmIssue } from '../../../../../assets/gcm-issue.svg';
import { ReactComponent as GcmAlert } from '../../../../../assets/gcm-alert.svg';
import { ReactComponent as GcmCancelation } from '../../../../../assets/gcm-cancelation.svg';
import { ReactComponent as GcmInCancellation } from '../../../../../assets/icons/u_alert-multyple.svg';

const statusIcons = {
    Issue: <GcmIssue />,
    Warning: <GcmAlert />,
    Cancelation: <GcmCancelation />,
    InCancellation: <GcmInCancellation />
}

const MilestonesAlert = ({ alert }) => {
    return (
        <div className='c-alerts'>
            <div>{statusIcons[alert.type]}</div>&nbsp;&nbsp;
            <p>{alert.descriptionName}</p>
        </div>
    ) 
}

export default MilestonesAlert